import { Box } from '@mui/material'
import React from 'react'

function Home() {
  return (
    <Box
      sx={{
        height: '88vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Welcome
    </Box>
  )
}

export default Home